import { isManualTopicsEnabled } from 'owa-topic-common/lib/utils/TopicsFeatureGate';

let isTopicPickerEnabledValue = undefined;
export default function isTopicPickerEnabled(): boolean {
    if (isTopicPickerEnabledValue === undefined) {
        isTopicPickerEnabledValue = isManualTopicsEnabled();
    }
    return !!isTopicPickerEnabledValue;
}
